import { logger } from "@games/logger-client";

import { applyPatch, Operation } from 'fast-json-patch';

interface StateData {
  state?: any;
  delta?: Operation[];
  privateData?: any;
  privateDelta?: Operation[];
  [key: string]: any;
}

export function createStateHandler() {
  let state: any = {};
  let privateData: any = {};

  return (data: StateData): StateData => {
    const { state: newState, delta, privateData: newPrivateState, privateDelta, ...rest } = data;
    try {
      if (newState !== undefined) {
        state = newState;
      } else if (delta) {
        state = applyPatch(state, delta, true, false).newDocument;
      }

      if (newPrivateState !== undefined) {
        privateData = newPrivateState;
      } else if (privateDelta) {
        privateData = applyPatch(privateData, privateDelta, true, false).newDocument;
      }

      const result = { ...rest };

      if (newState !== undefined || delta) {
        result.state = state;
      }

      if (newPrivateState !== undefined || privateDelta) {
        result.privateData = privateData;
      }

      return result;
    } catch (error) {
      logger.error('Error applying patch:', error);
      return { ...rest, state, privateData };
    }
  };
}